// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menzies-wizard {
  text-align: center;
  padding: 1rem;
  max-width: 64rem;
  margin: 0 auto;
}
.menzies-wizard .header-row {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  position: relative;
}
.menzies-wizard .header-row .btn {
  margin: 5px 0;
  z-index: 1;
}
.menzies-wizard .header-row h2 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
}
.menzies-wizard h1 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}
.menzies-wizard h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
}
.menzies-wizard .tables-box {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
  align-items: flex-start;
  margin: 2rem 0;
}
.menzies-wizard .tables-box table {
  flex: 1 1 350px;
  min-width: 320px;
  max-width: 500px;
  margin: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
}
.menzies-wizard table {
  width: 100%;
  font-size: 1rem;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 1.5rem;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  border: none;
}
.menzies-wizard table th {
  background: #f3f4f6;
  color: #22223b;
  font-weight: 700;
  padding: 0.75rem 1rem;
  border-bottom: 2px solid #e5e7eb;
  text-align: left;
}
.menzies-wizard table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
  transition: background 0.2s;
}
.menzies-wizard table tr:last-child td {
  border-bottom: none;
}
.menzies-wizard table tr:hover td {
  background-color: #f1f5f9;
  cursor: pointer;
}
.menzies-wizard .selected-row td {
  background-color: rgb(212, 211, 211);
  color: black;
}
.menzies-wizard .unselected-row td {
  background-color: white;
  color: black;
}
.menzies-wizard .status-green {
  color: #16a34a;
}
.menzies-wizard .status-orange {
  color: #ea580c;
}
.menzies-wizard .status-red {
  color: #dc2626;
}
.menzies-wizard .btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background-color: white;
  cursor: pointer;
}
.menzies-wizard .btn:hover {
  background-color: #f3f4f6;
}
.menzies-wizard .btn.btn-primary {
  background-color: #2563eb;
  color: white;
  border: none;
}
.menzies-wizard .btn.btn-primary:hover {
  background-color: #1d4ed8;
}
.menzies-wizard .btn.btn-success {
  margin-top: 15px;
  margin-left: 25px;
  background-color: #22c55e;
  color: white;
  border: none;
}
.menzies-wizard .btn.btn-success:hover {
  background-color: #16a34a;
}
.menzies-wizard .btn.btn-outline {
  background-color: white;
  border: 1px solid #9ca3af;
  color: #111827;
}
.menzies-wizard .btn.btn-outline:hover {
  background-color: #f3f4f6;
}
.menzies-wizard .single-btn-box {
  margin-top: 1.5rem;
  text-align: center;
}
.menzies-wizard .button-group {
  margin-top: 1.5rem;
  display: flex;
  justify-content: space-around;
  text-align: left;
}
.menzies-wizard .site-select-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
}
.menzies-wizard .site-select-container h2 {
  margin-bottom: 1rem;
  font-size: 1.1rem;
  color: #22223b;
  font-weight: 600;
}
.menzies-wizard .site-select-container select {
  padding: 0.5rem 1.2rem;
  font-size: 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  background: #fff;
  color: #22223b;
  margin-bottom: 0.5rem;
  transition: border 0.2s;
  outline: none;
  min-width: 220px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}
.menzies-wizard .site-select-container select:focus {
  border-color: #2563eb;
}
.menzies-wizard input[type=file] {
  margin: 1rem;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  color: #22223b;
  margin-bottom: 0.5rem;
  transition: border 0.2s;
  outline: none;
  cursor: pointer;
}

.image-page {
  color: #111827;
  border-radius: 8px;
  max-width: 800px;
  margin: 0 auto;
  height: 100vh;
}
.image-page h2 {
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: center;
}
.image-page h3 {
  text-align: center;
}
.image-page input[type=file] {
  display: block;
  margin: 1rem auto;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  background-color: #fff;
  color: #22223b;
  transition: border-color 0.2s;
}
.image-page .images-container {
  display: flex;
  gap: 10px;
}
.image-page .show-image {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  margin-top: 1rem;
}
.image-page .show-image img {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}
.image-page button.btn {
  display: block;
  margin: 1rem auto;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border: none;
  border-radius: 0.375rem;
  background-color: #22c55e;
  color: #fff;
  transition: background-color 0.2s;
}`, "",{"version":3,"sources":["webpack://./src/components/managerZone/eod/newspaperCouponsWizard/style.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AACI;EACE,aAAA;EACA,UAAA;AACN;AAEI;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,SAAA;AAAN;AAIE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHJ;AAKE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,uBAAA;EACA,cAAA;AAHJ;AAKI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,yCAAA;AAHN;AAOE;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yCAAA;EACA,YAAA;AALJ;AAOI;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,gCAAA;EACA,gBAAA;AALN;AAQI;EACE,qBAAA;EACA,gCAAA;EACA,gBAAA;EACA,2BAAA;AANN;AASI;EACE,mBAAA;AAPN;AAUI;EACE,yBAAA;EACA,eAAA;AARN;AAWG;EACC,oCAAA;EACA,YAAA;AATJ;AAWG;EACC,uBAAA;EACA,YAAA;AATJ;AAYE;EACE,cAAA;AAVJ;AAaE;EACE,cAAA;AAXJ;AAcE;EACE,cAAA;AAZJ;AAeE;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;AAbJ;AAeI;EACE,yBAAA;AAbN;AAgBI;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AAdN;AAgBM;EACE,yBAAA;AAdR;AAkBI;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;AAhBN;AAkBM;EACE,yBAAA;AAhBR;AAoBI;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;AAlBN;AAoBM;EACE,yBAAA;AAlBR;AAsBE;EACE,kBAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;AArBJ;AAwBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AAtBJ;AAwBI;EACE,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAtBN;AAyBI;EACE,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,yCAAA;AAvBN;AA0BI;EACE,qBAAA;AAxBN;AA4BE;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;AA1BJ;;AA8BA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AA3BF;AA6BE;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AA3BJ;AA6BE;EACE,kBAAA;AA3BJ;AA8BE;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;EACA,cAAA;EACA,6BAAA;AA5BJ;AA8BE;EACE,aAAA;EACA,SAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;AA7BJ;AA8BI;EACE,kBAAA;EACA,wCAAA;EACA,0BAAA;AA5BN;AAgCE;EACE,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,iCAAA;AA9BJ","sourcesContent":[".menzies-wizard {\n  text-align: center;\n  padding: 1rem;\n  max-width: 64rem;\n  margin: 0 auto;\n\n  .header-row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 1rem;\n    position: relative;\n\n    .btn {\n      margin: 5px 0 ;\n      z-index: 1;\n    }\n\n    h2 {\n      position: absolute;\n      left: 50%;\n      transform: translateX(-50%);\n      margin: 0;\n    }\n  }\n\n  h1 {\n    font-size: 1.5rem;\n    font-weight: 700;\n    margin-bottom: 1rem;\n  }\n\n  h2 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    margin-bottom: 1rem;\n  }\n  .tables-box {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2rem;\n    justify-content: center;\n    align-items: flex-start;\n    margin: 2rem 0;\n\n    table {\n      flex: 1 1 350px;\n      min-width: 320px;\n      max-width: 500px;\n      margin: 0;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);\n    }\n  }\n\n  table {\n    width: 100%;\n    font-size: 1rem;\n    border-collapse: separate;\n    border-spacing: 0;\n    margin-top: 1.5rem;\n    border-radius: 0.5rem;\n    overflow: hidden;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);\n    border: none;\n\n    th {\n      background: #f3f4f6;\n      color: #22223b;\n      font-weight: 700;\n      padding: 0.75rem 1rem;\n      border-bottom: 2px solid #e5e7eb;\n      text-align: left;\n    }\n\n    td {\n      padding: 0.75rem 1rem;\n      border-bottom: 1px solid #e5e7eb;\n      background: #fff;\n      transition: background 0.2s;\n    }\n\n    tr:last-child td {\n      border-bottom: none;\n    }\n\n    tr:hover td {\n      background-color: #f1f5f9;\n      cursor: pointer;\n    }\n  }\n   .selected-row td{\n    background-color: rgb(212, 211, 211) ;\n    color: black;\n  }\n   .unselected-row td{\n    background-color: white;\n    color: black;\n  }\n\n  .status-green {\n    color: #16a34a;\n  }\n\n  .status-orange {\n    color: #ea580c;\n  }\n\n  .status-red {\n    color: #dc2626;\n  }\n\n  .btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.875rem;\n    border: 1px solid #d1d5db;\n    border-radius: 0.375rem;\n    background-color: white;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #f3f4f6;\n    }\n\n    &.btn-primary {\n      background-color: #2563eb;\n      color: white;\n      border: none;\n\n      &:hover {\n        background-color: #1d4ed8;\n      }\n    }\n\n    &.btn-success {\n      margin-top: 15px;\n      margin-left: 25px;\n      background-color: #22c55e;\n      color: white;\n      border: none;\n\n      &:hover {\n        background-color: #16a34a;\n      }\n    }\n\n    &.btn-outline {\n      background-color: white;\n      border: 1px solid #9ca3af;\n      color: #111827;\n\n      &:hover {\n        background-color: #f3f4f6;\n      }\n    }\n  }\n  .single-btn-box {\n    margin-top: 1.5rem;\n    text-align: center;\n  }\n\n  .button-group {\n    margin-top: 1.5rem;\n    display: flex;\n    justify-content: space-around;\n    text-align: left;\n  }\n\n  .site-select-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 1.5rem 2rem;\n    margin-bottom: 2rem;\n\n    h2 {\n      margin-bottom: 1rem;\n      font-size: 1.1rem;\n      color: #22223b;\n      font-weight: 600;\n    }\n\n    select {\n      padding: 0.5rem 1.2rem;\n      font-size: 1rem;\n      border: 1px solid #cbd5e1;\n      border-radius: 0.375rem;\n      background: #fff;\n      color: #22223b;\n      margin-bottom: 0.5rem;\n      transition: border 0.2s;\n      outline: none;\n      min-width: 220px;\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n    }\n\n    select:focus {\n      border-color: #2563eb;\n    }\n  }\n\n  input[type=\"file\"] {\n    margin: 1rem;\n    padding: 0.5rem;\n    font-size: 1rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 0.375rem;\n    color: #22223b;\n    margin-bottom: 0.5rem;\n    transition: border 0.2s;\n    outline: none;\n    cursor: pointer;\n  }\n}\n\n.image-page {\n  color:#111827;\n  border-radius: 8px;\n  max-width: 800px;\n  margin: 0 auto;\n  height: 100vh;\n\n  h2 {\n    font-size: 1.8rem;\n    font-weight: bold;\n    margin-bottom: 1rem;\n    text-align: center;\n  }\n  h3{\n    text-align: center;\n  }\n\n  input[type=\"file\"] {\n    display: block;\n    margin: 1rem auto;\n    padding: 0.5rem;\n    font-size: 1rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 0.375rem;\n    background-color: #fff;\n    color: #22223b;\n    transition: border-color 0.2s;\n  }\n  .images-container{\n    display: flex;\n    gap: 10px;\n  }\n\n  .show-image {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    justify-content: center;\n    margin-top: 1rem;\n    img {\n      border-radius: 8px;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n      transition: transform 0.2s;\n    }\n  }\n\n  button.btn {\n    display: block;\n    margin: 1rem auto;\n    padding: 0.75rem 1.5rem;\n    font-size: 1rem;\n    border: none;\n    border-radius: 0.375rem;\n    background-color: #22c55e;\n    color: #fff;\n    transition: background-color 0.2s;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
